export const  GET_PRODUCTD_REQUEST  = "GET_PRODUCTD_REQUEST"
export const  GET_PRODUCTD_SUCCESS  = "GET_PRODUCTD_SUCCESS"
export const  GET_PRODUCTD_FAILURE  = "GET_PRODUCTD_FAILURE"


